import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const Wrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    backgroundColor: theme.palette.primitives.woodsmoke[1000],
    zIndex: 2,
    padding: '0 8px',
}));

export const HeaderSecondary = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'flex-start',
    gap: '24px',

    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: '12px',
        width: '100%',
        borderStyle: 'solid',
        borderColor: theme.palette.divider,
        borderBottomWidth: '1px',
        borderTopWidth: '1px',
    },
}));

export const InfoBlock = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    [theme.breakpoints.down('md')]: {
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '12px',
        borderColor: theme.palette.divider,
        borderBottomWidth: '1px',
        borderStyle: 'solid',
        padding: '0 5px 9px 5px',
        flexWrap: 'wrap',
    },
}));

export const LastUpdateBlock = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    [theme.breakpoints.down('md')]: {
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        borderColor: theme.palette.backgrounds.bg3,
        borderBottomWidth: '1px',
        borderStyle: 'solid',
        padding: '4px 0',
    },
}));
